// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AO2pcUy1Hj {
  width: 369px;
  padding: 4px;
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.06);
  float: left;
  background: #fff;
}
.AO2pcUy1Hj h4 {
  line-height: 3em;
}
.AO2pcUy1Hj .aUGf9dElS8 {
  float: left;
  width: 100%;
}
.AO2pcUy1Hj .Nz5DCMaoe_ {
  height: 40px;
  width: 60px;
  float: left;
  display: inline-block;
  min-height: 0;
  border-radius: 0;
  margin-bottom: 0;
  position: relative;
}
.AO2pcUy1Hj .Nz5DCMaoe_:hover {
  cursor: pointer;
}
.AO2pcUy1Hj .Nz5DCMaoe_:hover:after {
  position: absolute;
  content: "";
  z-index: 10;
  height: 40px;
  width: 60px;
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.3);
}
.zyXzySdpkZ .PQ9U03wnBR:focus {
  outline: none;
}
.zyXzySdpkZ .PQ9U03wnBR.zZ5t4ZBRTC.zDbWY2QOFO {
  background: #375A88;
}
.zyXzySdpkZ .PQ9U03wnBR.zZ5t4ZBRTC.zDbWY2QOFO span {
  color: #fff;
}
.zyXzySdpkZ .zDbWY2QOFO {
  background: #F5F4F9;
  border: 1px solid rgba(0, 0, 0, 0.06);
  color: rgba(0, 0, 0, 0.2);
}
.zyXzySdpkZ .zDbWY2QOFO:hover {
  background: #4F5157;
  color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.06);
}
.zyXzySdpkZ input {
  height: 38px;
  min-width: 220px;
}
.Nz5DCMaoe_.RpUm53V2G_ {
  background: #410102;
}
.Nz5DCMaoe_.oGrCiFa5cz {
  background: #911318;
}
.Nz5DCMaoe_.fgCHJjC_D2 {
  background: #D8293B;
}
.Nz5DCMaoe_.WC6QxnPbPx {
  background: #F2373C;
}
.Nz5DCMaoe_.GvmKf0WxqB {
  background: #FC4448;
}
.Nz5DCMaoe_.vYij6kI3tf {
  background: #ED535E;
}
.Nz5DCMaoe_.QOZ4zBi_1Z {
  background: #E34926;
}
.Nz5DCMaoe_.Uz196LjnnY {
  background: #FC562B;
}
.Nz5DCMaoe_.TdGiMeut3O {
  background: #FC6722;
}
.Nz5DCMaoe_.i0jw6ML33R {
  background: #FD7F24;
}
.Nz5DCMaoe_.ThV9HSTKYd {
  background: #FD8D26;
}
.Nz5DCMaoe_.ltc_0v5Nik {
  background: #EC9C3E;
}
.Nz5DCMaoe_.Wllj7vNazl {
  background: #0e673a;
}
.Nz5DCMaoe_.efrdUqaKaL {
  background: #208740;
}
.Nz5DCMaoe_.EM24Eflu0G {
  background: #239718;
}
.Nz5DCMaoe_.Lpc9OhQ91G {
  background: #55A84D;
}
.Nz5DCMaoe_._voUfLl3av {
  background: #4BBE5A;
}
.Nz5DCMaoe_.BKgbfuNJeT {
  background: #0CCA6A;
}
.Nz5DCMaoe_.YwxeCZaeib {
  background: #0A3C64;
}
.Nz5DCMaoe_.jiS7MMTD7F {
  background: #0d487a;
}
.Nz5DCMaoe_.YxjBcynl07 {
  background: #10538d;
}
.Nz5DCMaoe_.bSo3jFd54M {
  background: #115A99;
}
.Nz5DCMaoe_.EEHRhIw2RD {
  background: #3387E2;
}
.Nz5DCMaoe_.q1YrnuF1D_ {
  background: #1BA9CF;
}
.Nz5DCMaoe_.oCE1T1UJGO {
  background: #d27c02;
}
.Nz5DCMaoe_.NWgWYXX6OR {
  background: #fb9402;
}
.Nz5DCMaoe_._HhmtDNAfo {
  background: #FD9B30;
}
.Nz5DCMaoe_.gGhLKq5myO {
  background: #FDBE2D;
}
.Nz5DCMaoe_.tms6LvkEnT {
  background: #FED831;
}
.Nz5DCMaoe_.udh_BQCYaY {
  background: #FFFD38;
}
.Nz5DCMaoe_.z4pBOoQOTv {
  background: #2D215C;
}
.Nz5DCMaoe_.dYiXRmTE5o {
  background: #483C83;
}
.Nz5DCMaoe_.CSel8N75fj {
  background: #58518d;
}
.Nz5DCMaoe_.XJ6aXsyviZ {
  background: #7068A9;
}
.Nz5DCMaoe_.NuJ8rmGTKT {
  background: #7f78b2;
}
.Nz5DCMaoe_.z6KtrEYfG4 {
  background: #8f88bc;
}
.Nz5DCMaoe_.WXD49YqQWM {
  background: #000;
}
.Nz5DCMaoe_.ZIFeBOvNLG {
  background: #282626;
}
.Nz5DCMaoe_.IEvAxYWYO6 {
  background: #242222;
}
.Nz5DCMaoe_.I2VhRuh6hB {
  background: #353838;
}
.Nz5DCMaoe_.johABmgKG2 {
  background: #666;
}
.Nz5DCMaoe_.QY7IgrLEWg {
  background: #999;
}
.jSdrdObXzt {
  background: none;
  margin-top: 120px;
  position: relative;
  margin-left: 10px;
}
.jSdrdObXzt .YMXCaJnHZj {
  display: none;
}
.c1C7NWkFNS {
  min-width: 800px;
  text-align: center;
}
.SX5mTL7JZY {
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 12px;
  margin-top: 52px;
}
.QD5CxeJbOw {
  font-size: 12px;
  max-width: 370px;
  margin: 0 auto;
}
.GwUtRxp54y {
  margin-top: 40px;
}
.wJFMi7H6pZ {
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 16px;
}
.CYOM5lcbuh {
  display: flex;
  justify-content: center;
  margin-bottom: 55px;
}
.CYOM5lcbuh .iLTp07XaKA {
  width: 160px;
  font-weight: 300;
  letter-spacing: normal;
}
.CYOM5lcbuh .iLTp07XaKA.iLTp07XaKA.tch0HfhKDh {
  color: #222222;
}
.CYOM5lcbuh .iLTp07XaKA.iLTp07XaKA.tch0HfhKDh:hover {
  color: #fff;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"color-picker": `AO2pcUy1Hj`,
	"color-row": `aUGf9dElS8`,
	"color-tile": `Nz5DCMaoe_`,
	"picker-component": `zyXzySdpkZ`,
	"picker-element": `PQ9U03wnBR`,
	"active": `zZ5t4ZBRTC`,
	"btn": `zDbWY2QOFO`,
	"red-1": `RpUm53V2G_`,
	"red-2": `oGrCiFa5cz`,
	"red-3": `fgCHJjC_D2`,
	"red-4": `WC6QxnPbPx`,
	"red-5": `GvmKf0WxqB`,
	"red-6": `vYij6kI3tf`,
	"orange-1": `QOZ4zBi_1Z`,
	"orange-2": `Uz196LjnnY`,
	"orange-3": `TdGiMeut3O`,
	"orange-4": `i0jw6ML33R`,
	"orange-5": `ThV9HSTKYd`,
	"orange-6": `ltc_0v5Nik`,
	"green-1": `Wllj7vNazl`,
	"green-2": `efrdUqaKaL`,
	"green-3": `EM24Eflu0G`,
	"green-4": `Lpc9OhQ91G`,
	"green-5": `_voUfLl3av`,
	"green-6": `BKgbfuNJeT`,
	"blue-1": `YwxeCZaeib`,
	"blue-2": `jiS7MMTD7F`,
	"blue-3": `YxjBcynl07`,
	"blue-4": `bSo3jFd54M`,
	"blue-5": `EEHRhIw2RD`,
	"blue-6": `q1YrnuF1D_`,
	"yellow-1": `oCE1T1UJGO`,
	"yellow-2": `NWgWYXX6OR`,
	"yellow-3": `_HhmtDNAfo`,
	"yellow-4": `gGhLKq5myO`,
	"yellow-5": `tms6LvkEnT`,
	"yellow-6": `udh_BQCYaY`,
	"purple-1": `z4pBOoQOTv`,
	"purple-2": `dYiXRmTE5o`,
	"purple-3": `CSel8N75fj`,
	"purple-4": `XJ6aXsyviZ`,
	"purple-5": `NuJ8rmGTKT`,
	"purple-6": `z6KtrEYfG4`,
	"black-1": `WXD49YqQWM`,
	"black-2": `ZIFeBOvNLG`,
	"black-3": `IEvAxYWYO6`,
	"black-4": `I2VhRuh6hB`,
	"black-5": `johABmgKG2`,
	"black-6": `QY7IgrLEWg`,
	"picker-theme": `jSdrdObXzt`,
	"arrow-regular": `YMXCaJnHZj`,
	"new-review-round": `c1C7NWkFNS`,
	"new-review-round__content--title": `SX5mTL7JZY`,
	"new-review-round__content--text": `QD5CxeJbOw`,
	"new-review-round__actions": `GwUtRxp54y`,
	"new-review-round__actions--confirm": `wJFMi7H6pZ`,
	"new-review-round__actions--buttons": `CYOM5lcbuh`,
	"custom-button": `iLTp07XaKA`,
	"custom-cancel-button": `tch0HfhKDh`
};
export default ___CSS_LOADER_EXPORT___;
